// Core
import React, { useState } from 'react';
import { Box, Button, Flex, Text, Divider, Grid, Image, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import glow from 'assets/img/main-prizes.png';
import phone from 'assets/img/main-screen-1.png';
import phoneWhite from 'assets/img/main-screen-white-2.png';
import petrolImage from 'assets/img/petrol.png';
import cars from 'assets/img/cars.png';
import house from 'assets/img/house.png';
import merch from 'assets/img/merch.png';
import allPrizes from 'assets/img/all-prizes.png';
import featuredImage1 from 'assets/img/featured-image-1.png';
import featuredImage2 from 'assets/img/featured-image-2.png';
import featuredImage3 from 'assets/img/featured-image-3.png';
import featuredImage4 from 'assets/img/featured-image-4.png';
import animatedHome from 'assets/img/login/home.png';
import animatedCar1 from 'assets/img/login/car1.png';
import animatedCar2 from 'assets/img/login/car2.png';
import animatedCrystal from 'assets/img/login/crystal.png';
import animatedTicket from 'assets/img/login/ticket.png';
import animatedBox from 'assets/img/login/box.png';
import { getLinkLoyaltyMembership, getLinkPetrolMembership } from 'services/Utils';

// Components
import { StarsIcon, MapIcon, ArrowDiscountIcon } from 'components/Icons/Icons';
import Card from 'components/Card/Card';
import PetrolStation from './components/PetrolStation';
import TypeCard from './components/TypeCard';
import PartnersDoubles from 'components/Sliders/PartnersDoubles';
import FeaturedOn from './components/FeaturedOn';
import HowItWorks from './components/HowItWorks';
import Giveaways from './components/Giveaways';
import GiveawayWinners from './components/GiveawayWinners';
import Membership from 'components/Membership/Membership';
import Entries from 'components/Membership/Entries';
import ExclusiveSavings from './components/ExclusiveSavings';
import ExclusiveContent from './components/ExclusiveContent';
import Privileges from './components/Privileges';
import RewardsClub from './components/RewardsClub';
import Reviews from 'components/Sliders/Reviews';
import Li from 'components/Lists/List';

const Home = ({ userData }) => {
  const bgDivider = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #9EDFFF 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const bgDividerWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 9.63%, #38A9E1 37.41%, #38A9E1 50%, #38A9E1 60.02%, rgba(56, 169, 225, 0.00) 91.14%)';
  const cardTopLine = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 56.18%, #FFF 68.16%, #38A9E1 82.69%, rgba(56, 169, 225, 0.00) 100%)';
  const textColor = useColorModeValue('#0E1633', 'white'); 
  const textColorViewAllButton = useColorModeValue('#262D47', '#9FABCB');
  const textColorViewAllArrow = useColorModeValue('white', '#0E1633');
  const { colorMode } = useColorMode();
  const isDark = colorMode === 'dark';

  const [membershipData, setMembershipData] = useState([]);
  const [paymentType, setPaymentType] = useState('yearly');

  const [giveawayWinnersIsHidden, setGiveawayWinnersIsHidden] = useState(true);
  const [famousGiveawayIsHidden, setFamousGiveawayIsHidden] = useState(true);

  return (
    <>
      <Box 
        position="relative" 
        p={{ base: '0 0 60px 0 ', sm: '0 80px 100px 80px', lg: '0 0 100px 0' }}
        w={{ base: '100%' }}
        left={{ base: '0' }}
        float="unset"
        alignItems="center"
        justifyContent="center"
        m={{ base: '-100px auto 0px auto', md: '0px auto' }}
        maxW="867px">
        { isDark && <Box className="abstract-grad animation-scale-grad" mt={{base: '170px', md: '50px'}} />}
        { isDark ?  <Lines className="abstract-lines" /> :  <LinesWhite className="abstract-lines" />}
        { isDark && <Box className="abstract-grad animation-scale-grad" left="60%" transform="scale(1.7)" bottom="30%" />}
        <Image src={ isDark ? phone : phoneWhite } alt='phone' 
          right={{sm: '100px', md: '100px', lg: '-52px'}}
          top={{base: '50px', sm: '-20px', md: '-95px', lg: '-98px'}}
          maxW={{base: '320px', sm: '260px', md: '435px', lg: '545px'}}
          left={{base: '43%', sm: 'unset'}}
          transform={{base: 'translate(-50%, 0px)', sm: 'unset'}}
          w="100%" position="absolute" zIndex="-1"/>
        <Box 
          className="abstract-grad" 
          left={{base: '20%',sm: '40%', md: '60%'}}
          transform="scale(1.1)" 
          bottom={{base: '60%', sm: '60%', md: '30%'}} />
        <Image src={glow} alt='glow'
          right={{sm: '-10px', md: '-10px', lg: '-134px'}}
          top={{base: '250px', sm: '90px', md: '218px'}}
          maxW={{base: '290px', sm: '230px', md: '410px', lg: '510px'}}
          left={{base: '57%', sm: 'unset'}}
          transform={{base: 'translate(-50%, 0px)', sm: 'unset'}}
          w={{base: '460px', sm: '100%'}} position="absolute" 
          zIndex={{base: '1', sm: '-1'}}/>
        <Box 
          display={{base: 'block', md: 'none'}}
          bg={ isDark ? '#00071C' : '#dfe9fd'} zIndex="-1" filter="blur(60px)" opacity="0.8" borderRadius="100%" w={{base: '100%', sm: '70%', md: 'none'}} h="290px" position="absolute" />
        
        <Text as="h1" mt="145px">
          <Text as="span" variant="header" pl="12px"
            fontSize={{base: '36px', md: '64px', lg: '72px'}}
            >AUSTRALIA`S</Text><br />
          <Text as="span" variant="header-gradient" mt="-12px" w="fit-content" 
            lineHeight={{base: '64px', lg: '97px'}}
            fontSize={{base: '72px', md: '96px', lg: '128px'}}
            pr={{base: '8px'}}
            >
            BEST<Divider borderWidth="0" bottom={{base: '8px', sm: '12px', lg: '20px'}} h="2px" bg={ isDark ? bgDivider : bgDividerWhite} position="absolute" /></Text><br />
          <Flex alignItems="center" 
            gap={{base: '8px' ,sm: '24px'}} 
            mt={{base: '16px', md: '18px', lg: '18px'}}>
            <StarsIcon fontSize={{base: '24px', md: '42px'}} />
            <Box
               as="span"
               borderRadius={{base: '8px', sm: '16px'}}
               p={{base: '3px 2px 3px 10px', sm: '3px 18px 3px 24px'}}
               w={{sm: 'min-content', lg: 'unset'}}
               textAlign={{sm: 'center', lg: 'unset'}}
               background="white">
              <Text 
                variant="header-gradient" 
                pr={{base: '8px'}}
                fontSize={{base: '36px', md: '64px', lg: '72px'}}>REWARDS CLUB</Text>
            </Box>
          </Flex>
          <Text as="span" variant="header" 
            lineHeight={{base: '54px', lg: '81px'}}
            fontSize={{base: '28px', md: '36px', lg: '48px'}}
            >& Shopping Tool</Text>
          <Text as="span" variant="header-gradient" 
            m={{base: '', md: '-8px 0 20px 0'}}
            zIndex="9"
            display="block"
            bg="linear-gradient(180deg, #14CC10 0%, #086908 100%)"
            fontSize={{base: '28px', md: '32px'}}>
            + PETROL WHOLESALE PRICES
          </Text>
        </Text>

        <Text as="h2" maxW={{base: '100%', md: '46%'}} color={textColor} mt={{base: '290px', sm: '4px'}}>
        	Welcome to LMCT+, the premier shopping tool of Australia. 
      	    With a robust dashboard and user-friendly mobile app, 
      	    LMCT+ offers Australian users unparalleled savings opportunities.
        </Text>

        <a href={getLinkLoyaltyMembership()} alt="Sign Up">
        {/* <NavLink to="/auth/login"> */}
        <Button variant={ isDark ? 'button-lg-g' : 'button-lg' } maxW={{base: '100%', sm: '280px'}} mt={{base: '24px', sm: '38px'}}>Join Now</Button>
        {/* </NavLink>  */}
        </a>
      </Box>

      <ExclusiveContent />

      <PetrolStation />

      <Grid templateColumns={{ sm: '1fr', md: '1fr 1fr' }} gap="24px" rowGap={{ base: '60px', md: '0'}} templateRows='1fr' mb={{base: '60px', md: 'unset'}} mt={{base: '80px', sm: '60px', lg: '100px'}}>
        <TypeCard 
            src={petrolImage} 
            title="LMCT+ Petrol" 
            description="Save on fuel with LMCT+ fuel stations. Get wholesale pricing at a daily fixed rate, unlock discounts, earn rewards, and climb the leaderboard with Entry, Premium, Elite, or Fuel Saver memberships."
        />
        <TypeCard 
            src={cars} 
            title="Automotive" 
            description="Your one-stop-shop for exclusive offers from Australia’s leading performance & tuning workshops, panel beaters, aftermarket parts & accessories, and everything else automotive."
        />
        <TypeCard 
            src={house} 
            title="Homewares & services" 
            description="We’ve teamed up with the best in the business to bring you amazing deals on furniture, homeware, stylish decor, electrical, plumbing, and so much more to create comfort and elegance in your home!"
        />
        <TypeCard 
            src={merch} 
            title="Merchandise" 
            description="Your go-to destination for exclusive deals on premium apparel, accessories, and must-have merchandise from top brands across Australia, to elevate your style with a fresh, branded look."
        />
      </Grid>

      <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt="16px">Our partners & DISCOUNTS</Text>
      <PartnersDoubles />

      <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} mt={{base: '60px', md: '80px'}} fontStyle="normal">ABOUT US</Text>
      <Grid templateColumns={{ sm: '1fr', md: '0.6fr 0.9fr 1fr' }} gap="24px" templateRows='1fr' mt={{base: '16px', md: '28px'}}>
        <Box>
            { isDark && <Box className="abstract-grad" mt="50px" transform="scale(0.6)" /> }

            <Flex gap="8px">
                 <Text variant="header" fontSize={{base: '48px', md: '64px'}}>2000</Text>
                 <Text variant="header-gradient" fontSize={{base: '48px', md: '64px'}} mt="3px">+</Text>
            </Flex>
            <Text variant="title-sm" fontSize="13px" textTransform="uppercase" mt={{base: '0px', md: '6px'}}>Australian business partners</Text>
        </Box>

        <Box>
            { isDark && <Box className="abstract-grad" mt="50px" transform="scale(0.6)" />}

            <Flex gap="8px">
                 <Text variant="header" fontSize={{base: '48px', md: '64px'}}>$1000</Text>
                 <Text variant="header-gradient" textTransform="none" fontSize={{base: '48px', md: '64px'}} mt={{base: '4px', md: '6px'}}>s</Text>
            </Flex>
            <Text variant="title-sm" fontSize="13px" textTransform="uppercase" mt={{base: '0px', md: '6px'}}>In savings through our mates rates discounts</Text>
        </Box>

        <Box>
            { isDark && <Box className="abstract-grad" mt="50px" transform="scale(0.6)" />}

            <Flex gap="8px">
                 <Text variant="header" fontSize={{base: '48px', md: '64px'}}>1500</Text>
                 <Text variant="header-gradient" fontSize={{base: '48px', md: '64px'}} mt="3px">+</Text>
            </Flex>
            <Text variant="title-sm" fontSize="13px" textTransform="uppercase" mt={{base: '0px', md: '6px'}}>Stores you can redeem offers in person or online</Text>
        </Box>
      </Grid>
      <Grid templateColumns={{ sm: '1fr', md: '0.8fr 1fr' }} gap="24px" templateRows='1fr' mt={{base: '24px', md: '44px'}}>
        <Box>
            <Li text="Welcome to LMCT+, the premier shopping tool of Australia. With a robust dashboard and user-friendly mobile app, LMCT+ offers Australian users unparalleled savings opportunities." />
            <Li text="Our platform not only facilitates access to exclusive deals from more than 2,000 partners 
              but also empowers shoppers to make smart, cost-effective purchases all in one place. At LMCT+, 
              our users are not just visitors; they are paying members with a vested interest in 
              utilizing our software to its fullest potential. This high intent to purchase makes 
              our platform an attractive venue for advertisers and partners, ensuring high engagement 
              rates and genuine transactions." />
            <Li text="Additionally, we pride ourselves on securing exclusive partnerships that provide unique discounts specifically for LMCT+ members, a benefit not commonly found with typical affiliate programs." />

            <a href={getLinkLoyaltyMembership()} alt="Sign Up"> 
            {/* <NavLink to="/auth/login">*/}
                <Button mt={{base: '24px', md: '40px'}} variant={ isDark ? 'button-lg-g' : 'button-lg' } w={{base: '100%', md: '280px'}}>Join Now</Button>
            {/* </NavLink> */}
            </a> 
        </Box>

        <Box position="relative" display={{base: 'none', md: 'block'}}>
            <MapIcon position="absolute" fontSize="1360px" 
                style={{zIndex: '-1', width: '1360px', left: '-95%', top: '-210px', height: '776px', opacity: '0.1'}}
                />
            <Box 
              mt={{md: '80px', lg: '50px'}}
              position="relative" 
              h={{base: '70%', lg: '90%'}}
              left={{base: '-10%', lg: '-3%'}}
              transform={{base: 'scale(0.8)', lg: 'scale(1)'}}>
                <Box position="absolute" className="animation-prizes" bottom="10%" left="25%" w="400px" h="400px">
                  { isDark && <Box w="400px" h="400px" position="absolute" bg="#099BFF" filter="blur(90px)" borderRadius="full" left="-10%" top="-10%" className="animation-prizes-gradient"/>}
                  <Image src={animatedHome} alt="Home" w="325px" bottom="-4px" left="-2px" className="animation-prizes-home" zIndex="8" />
                  <Image src={animatedCar1} alt="Car" w="205px" bottom="8px" left="-82px" transform="rotate(0deg)" className="animation-prizes-car1" zIndex="7" />
                  <Image src={animatedCar2} alt="Car" w="205px" bottom="-1px" right="-16px" transform="rotate(0deg)" className="animation-prizes-car2" zIndex="7" />
                  <Image src={animatedCrystal} alt="Crystal" w="100px" bottom="119px" left="-66px" transform="rotate(-22deg)" zIndex="6" className="animation-prizes-crystal1" />
                  <Image src={animatedCrystal} alt="Crystal" w="145px" bottom="140px" left="-30px" transform="rotate(19deg)" zIndex="6" className="animation-prizes-crystal2" />
                  <Image src={animatedTicket} alt="Ticket" w="110px" bottom="136px" right="86px" transform="rotate(-44deg)" zIndex="5" className="animation-prizes-ticket1" />
                  <Image src={animatedTicket} alt="Ticket" w="70px" bottom="141px" right="53px" transform="rotate(-119deg)" zIndex="5" className="animation-prizes-ticket2" />
                  <Image src={animatedBox} alt="Box" w="300px" bottom="33px" left="-6px" transform="rotate(15deg) scale(1)" zIndex="1" className="animation-prizes-box" />
                </Box>
            </Box>
        </Box>
      </Grid>

      <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} mt={{base: '60px', sm: '80px', md: '100px', lg: '130px'}} fontStyle="normal">Featured on</Text>
      <Grid templateColumns={{ base: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr 1fr' }} rowGap="8px" gap="24px" templateRows='1fr' mt={{base: '24px', md: '32px'}}>
        <FeaturedOn image={featuredImage1} />
        <FeaturedOn image={featuredImage2} />
        <FeaturedOn image={featuredImage3} />
        <FeaturedOn image={featuredImage4} />
      </Grid>

      <Text as="h4" variant="header" fontStyle="normal" fontSize={{base: '24px', md: '32px'}} mt={{base: '50px', sm: '55px'}} mb={{base: '24px', sm: '32px'}}>How It Works?</Text>
      <HowItWorks />

      { !famousGiveawayIsHidden && (
        <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt={{base: '45px', sm: '60px'}} mb={{base: '24px', sm: '32px'}}>The Famous LMCT+ Giveaways</Text>
      )}
      <Giveaways setFamousGiveawayIsHidden={setFamousGiveawayIsHidden} userData={userData} />

      { !giveawayWinnersIsHidden && (
        <Flex justifyContent="space-between" alignItems="center" mt={{base: '50px', md: '73px'}} mb={{base: '24px', sm: '32px'}}>
          <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" pr="10px">Previous Winners</Text>
          <NavLink to="/giveaways">
            <Button variant="secondary-md" w="144px" color={textColorViewAllButton} fontWeight="500" borderRadius="full">
              VIEW ALL <ArrowDiscountIcon fontSize="24px" />
            </Button>
          </NavLink>
        </Flex>
      )}
      <GiveawayWinners setGiveawayWinnersIsHidden={setGiveawayWinnersIsHidden} />

      <Box mt={{base: '60px', sm: '100px'}} />
      <Membership variant="home" setMembershipData={setMembershipData} paymentType={paymentType} setPaymentType={setPaymentType} />
      { membershipData?.length > 0 &&
        <Entries membershipData={membershipData} membershipPaymentType={paymentType} />
      }

      <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt={{base: '60px', sm: '73px'}} mb={{base: '24px', sm: '32px'}}>Exclusive Savings</Text>
      <ExclusiveSavings />

      <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt={{base: '60px', sm: '73px'}} mb={{base: '24px', sm: '32px'}}>Membership privileges</Text>
      <Privileges />

      <Text id="download" as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt="-60px" pt={{base: '120px', sm: '133px'}} mb={{base: '24px', sm: '32px'}}>Rewards Club</Text>
      <RewardsClub />

      <Text as="h4" variant="header" fontSize={{base: '24px', md: '32px'}} fontStyle="normal" mt={{base: '60px', sm: '73px'}} mb={{base: '24px', sm: '32px'}}>Clients Reviews</Text>
      <Reviews />

      <Box pt={{base: '60px', md: '150px'}} />
    </>
  );
};

export default Home;